import { Injectable } from '@angular/core';
import { CLAIRE_CONFIG_DEFAULT_AREAS, CLAIRE_CONFIG_DEFAULT_FUNCTIONS } from './claire-config-defaults';
import { TLArea, TLFunctionType, TLAreaType, TLAreaFunction } from './area-function';
import { signal, WritableSignal } from '@angular/core';
import { ShellEmittersService } from '../shell-emitters.service';

@Injectable({
    providedIn: 'root'
})
export class ClaireConfigService {

    public isClaireEnabledByConfig: WritableSignal<boolean> = signal(false);
    public areas: WritableSignal<{ [key in TLAreaType]: TLArea }> = signal({ ...CLAIRE_CONFIG_DEFAULT_AREAS });
    public functions: WritableSignal<{ [key in TLFunctionType]: TLAreaFunction }> = signal({ ...CLAIRE_CONFIG_DEFAULT_FUNCTIONS });

    public id = '';

    constructor(
        private shellEmittersService: ShellEmittersService
    ) {
        this.id = crypto.randomUUID().toString();
        (window as any).claireConfig = this;
    }

    public loadConfig(dbConfig: any) {
        this.isClaireEnabledByConfig.set(dbConfig?.enabled ?? true);
        //
        const areas = { ...CLAIRE_CONFIG_DEFAULT_AREAS };
        if (dbConfig) {
            for (const area in areas) {
                const en = (dbConfig.areas ? (dbConfig.areas.includes(area) ? true : false) : false);
                areas[area as keyof typeof this.areas].enabled = en;
            }
        }
        this.areas.set(areas);
        //
        const functions = { ...CLAIRE_CONFIG_DEFAULT_FUNCTIONS };
        if (dbConfig) {
            for (const functionType in functions) {
                const en = (dbConfig.functions ? (dbConfig.functions.includes(functionType) ? true : false) : false);
                functions[functionType as keyof typeof this.functions].enabled = en;
            }
        }
        this.functions.set(functions);
        this.shellEmittersService.onClaireLoadedConfig.emit();
    }

}
